export let storeKey = "purchaseValues";
